import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LogoutIcon = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M4.667 14.667H3.333a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2h1.334a.667.667 0 1 0 0-1.333H3.333A3.337 3.337 0 0 0 0 3.333v9.334A3.337 3.337 0 0 0 3.333 16h1.334a.666.666 0 1 0 0-1.333Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "m12.359 12.471 3.058-3.057a2.005 2.005 0 0 0 0-2.828l-3.058-3.057a.667.667 0 0 0-.943.942l2.861 2.862H4a.667.667 0 0 0 0 1.334h10.278l-2.862 2.862a.666.666 0 1 0 .943.942Z"
  })]
});
export default LogoutIcon;